import AiLabel from "@/components/ai-label";
import Category from "@/components/category";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type VerticalProps = {
  article: Content.Article;
  hideDownPull?: boolean;
  hideTitle?: boolean;
};

const Vertical = (props: VerticalProps) => {
  const category = props.article.fields.categories?.[0];
  const image = props.article.fields.images?.[0];

  return (
    <Link
      key={props.article.sys.id}
      href={`/${props.article.fields.slug}`}
      className="group block relative"
    >
      {image?.fields?.file?.url && (
        <div className="aspect-w-9 aspect-h-16">
          <Image
            src={createImageUrl(image.fields.file.url, { crop: "9:16" })}
            alt={image.fields.alt || ""}
            fill
            sizes={createImageSizes({
              mobile: "33vw",
              tablet: "33vw",
              desktop: "33vw",
            })}
            className="object-cover"
          />
          <AiLabel image={image} />
        </div>
      )}
      {!props.hideTitle && (
        <>
          <div className="absolute inset-x-6 bottom-6 z-10 text-center justify-center">
            {category && (
              <div className="flex items-center justify-center">
                <Category category={category} inverted />
              </div>
            )}

            {props.article.fields.title && (
              <h2 className="text-3xl text-white-500 font-semibold group-hover:underline">
                {props.article.fields.title}
              </h2>
            )}
          </div>
          <div className="absolute inset-x-0 bottom-0 bg-overlay h-64" />
        </>
      )}
    </Link>
  );
};

export default Vertical;
